/**
 * Model reprezentujący strukturę sekcji FAQ (Często Zadawane Pytania) dla konkretnego Abonamentu.
 * Pozwala na wyświetlenie listy rozwijanej z pytaniami w szczegółach abonamentu.
 */
export class CarePlanFaq {
  /** Lista par Pytanie-Odpowiedź. */
  public elements: CarePlanFaqElement[];

  /** Tytuł całej sekcji FAQ wyświetlany nad listą. */
  public title: string;
}

/**
 * Pojedynczy element (wiersz) w sekcji FAQ Planu Opieki.
 * Zawiera treść pytania oraz odpowiedź.
 */
export class CarePlanFaqElement {
  /** Treść pytania (nagłówek akordeonu). */
  public question: string;

  /** Treść odpowiedzi (ciało akordeonu). */
  public answer: string;
}
